import React, { useEffect, useReducer, useState } from "react";
import { currentTeamId } from "../Utils/utils";
import {
  FETCH_DUPLICATE_ENTRIES,
  REMOVE_DUPLICATES,
} from "../GraphApi/Contacts/DuplicateContacts";
import { useLazyQuery, useMutation } from "@apollo/client";
// import { TrialPlanChecker } from "./TrialPlanChecker";

const initialState = {
  isFetching: false,
  contacts: null,
  duplicatesCount: 0,
  isContactRemoved: false,
  error: null,
};

export const DuplicateContactsContext = React.createContext();

function DuplicateContactReducer(state, action) {
  switch (action.type) {
    case "GET_DUPLICATE_REQUEST":
      return { ...state, isFetching: true };
    case "REMOVE_DUPLICATE_REQUEST":
      return { ...state, isFetching: true };
    case "REMOVE_DUPLICATE_SUCCESS":
      return { ...state, isContactRemoved: true };
    case "DUPLICATE_SUCCESS":
      return {
        ...state,
        isFetching: false,
        contacts: action.payload.contacts,
        total: action.payload.total,
        totalCount: action.payload.totalCount,
        duplicatesCount: action?.payload?.contacts?.length,
        // ? action.payload.contacts.reduce(
        //     (total, currentValue, currentIndex, arr) => {
        //       return (
        //         total +
        //         (currentValue.contacts.length > 1
        //           ? currentValue.contacts.length
        //           : 0)
        //       );
        //     },
        //     0
        //   )
        // : 0,
        error: null,
        isContactRemoved: false,
      };
    case "DUPLICATE_FAILURE":
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    default:
      return state;
  }
}

const DuplicateContactsContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    DuplicateContactReducer,
    initialState,
    undefined
  );
  const [pageParams, setPageParams] = useState({
    first: 10,
    page: 1,
  });

  // const { planData, isPlanExpired } = useContext(TrialPlanChecker);

  const [fetchDuplicateEntries] = useLazyQuery(FETCH_DUPLICATE_ENTRIES, {
    fetchPolicy: "no-cache",
  });
  const [removedDuplicates] = useMutation(REMOVE_DUPLICATES);

  const resolveTeamId = () => {
    const parsedCurrent = parseInt(currentTeamId, 10);
    if (!isNaN(parsedCurrent)) {
      return parsedCurrent;
    }
    try {
      if (typeof window !== "undefined") {
        const stored = window.localStorage.getItem("currentTeam");
        const parsedStored = parseInt(stored, 10);
        if (!isNaN(parsedStored)) {
          return parsedStored;
        }
      }
    } catch (error) {
      // no-op
    }
    return null;
  };

  // reload duplicate entries after set interval...
  const loadDuplicateEntries = (overrides = {}) => {
    const activeTeamId = resolveTeamId();
    if (!activeTeamId) {
      return;
    }
    const variables = {
      ...pageParams,
      team_id: activeTeamId,
      ...overrides,
    };
    // if (planData !== null) {
    //   if (isPlanExpired) {
    //     return false;
    //   } else {
    fetchDuplicateEntries({
      variables,
      fetchPolicy: "no-cache",
    })
      .then((result) => {
        if (result.data && !result.error) {
          const contactsData = result.data.fetchDuplicateEntries.data.filter(
            (entry) => entry?.contacts?.length > 0
          );

          dispatch({
            type: "DUPLICATE_SUCCESS",
            payload: {
              contacts: [
                ...(state?.contacts?.length > 0 ? state.contacts : []),
                ...contactsData,
              ],
              total:
                result?.data?.fetchDuplicateEntries?.paginatorInfo?.total || 0,
              totalCount:
                parseInt(state.totalCount) +
                parseInt(result.data.fetchDuplicateEntries.data.length),
            },
          });
        }
      })
      .catch((error) => {
        console.log("error:", error);
        let { graphQLErrors } = error;
        dispatch({ type: "DUPLICATE_FAILURE", payload: graphQLErrors });
      });
    // }}
  };

  //send remove request to backend to remove user selected duplicate contact...
  const removeContact = (contactId, duplicateId) => {
    const activeTeamId = resolveTeamId();
    if (!activeTeamId) {
      return;
    }
    removedDuplicates({
      variables: {
        teamId: activeTeamId,
        contactId: parseInt(contactId),
        duplicateId: parseInt(duplicateId),
      },
    })
      .then((result) => {
        dispatch({ type: "REMOVE_DUPLICATE_SUCCESS" });
        value.getDuplicateData();
        // deleteRemovedContacts(contactId);
        // handleAlertMessage("success", "Remove contact successfully");
      })
      .catch((error) => {
        let { graphQLErrors } = error;
        console.log("error:", error);
        dispatch({ type: "DUPLICATE_FAILURE", payload: graphQLErrors });
      });
  };

  useEffect(() => {
    if (pageParams && pageParams?.page > 1) {
      dispatch({ type: "GET_DUPLICATE_REQUEST" });
      loadDuplicateEntries();
    }
  }, [pageParams]);

  /*******/
  const value = {
    duplicateData: {
      isFetching: state.isFetching,
      contacts: state.contacts,
      duplicatesCount: state.duplicatesCount,
      total: state.total,
      totalCount: state.totalCount,
      isContactRemoved: state.isContactRemoved,
      error: state.error,
    },

    getDuplicateData: () => {
      dispatch({ type: "GET_DUPLICATE_REQUEST" });
      loadDuplicateEntries();
    },

    setDuplicateData: (data) => {
      dispatch({ type: "DUPLICATE_SUCCESS", payload: data });
    },

    removeDuplicateData: (contactId, duplicateId) => {
      dispatch({ type: "GET_DUPLICATE_REQUEST" });
      removeContact(contactId, duplicateId);
    },

    loadMore: () => {
      if (state.duplicatesCount !== state.total) {
        setPageParams({
          ...pageParams,
          page: parseInt(pageParams.page) + 1,
        });
      }
    },
  };

  return (
    <DuplicateContactsContext.Provider value={value}>
      {children}
    </DuplicateContactsContext.Provider>
  );
};

export default DuplicateContactsContextProvider;
